import React from 'react';
import { qualityContent } from '@/content/quality';
import QualityFactor from './QualityFactor';
import { Section } from '@/components/ui';

const Quality: React.FC = () => {
    return (
        <Section id="quality" className="quality" title={qualityContent.sectionTitle}>
            <div className="trust-icons">
                {qualityContent.factors.map((factor, index) => (
                    <QualityFactor key={factor.title} {...factor} delay={index * 100} />
                ))}
            </div>
        </Section>
    );
};

export default Quality;
